<style lang="scss" scoped>
.slide-14 {
  background-image: url(../../../assets/module4/slide14/bg-05.jpg);
  background-position: center;
  background-size: cover;
  padding-top: 60px;
  padding-left: 260px;
  height: calc(100% - 60px);
}
h1 {
  font-size: 98px;
  color: #3b7fc2;
  & + h1 {
    color: #ed8595;
    text-align: center;
  }
}
.header {
  z-index: 1;
  position: relative;
  max-width: 1200px;
  transform: rotate(-4deg);
}
.content {
  margin-left: 300px;
  max-width: 710px;
  margin-top: 20px;
}
p {
  margin-bottom: 50px;
}
h2 {
  color: #edad0a;
  font-size: 49px;
  line-height: 58px;
  text-align: right;
  margin-top: -1em;
  margin-right: -1em;
}
video {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  height: 100%;
  z-index: 999;
  box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.9);
}
.highfive {
  transition: all 0.2s ease-out;
  width: 307px;
  display: block;
  position: absolute;
  top: 40px;
  right: 400px;
  z-index: 99;
  img {
    width: 100%;
    height: auto;
  }
  &:hover {
    transform: scale(1.1);
  }
}
</style>

<template>
  <div class="slide-14">
    <transition name="fadeUp" appear>
      <video
        v-if="showVid"
        ref="video"
        autoplay
        src="@/assets/highfive.mp4"
      ></video>
    </transition>
    <transition name="fadeLeft" appear>
      <img
        src="@/assets/module4/slide14/sophia-05.png"
        class="chars"
        v-show="slideIndex == 13"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        src="@/assets/module4/slide14/images-05.png"
        class="chars"
        v-show="slideIndex == 13"
      />
    </transition>
    <div class="header">
      <transition name="fadeUp" appear>
        <h1 v-show="slideIndex == 13" class="delay-1">HEY HIGH FIVE -</h1>
      </transition>
      <transition name="fadeUp" appear>
        <h1 v-show="slideIndex == 13" class="delay-2">
          YOU’VE FINISHED<br />PART 4 OF YOUR MISSION
        </h1>
      </transition>
    </div>
    <div class="content">
      <transition name="fadeUp" appear>
        <p v-show="slideIndex == 13" class="delay-3">
          Time for me to say goodbye but remember to tell your parents what you
          learned today. Tell them what a stroke is and how it can affect our
          Grandheroes.
        </p>
      </transition>
      <transition name="fadeUp" appear>
        <p v-show="slideIndex == 13" class="delay-4">
          Tell them about the Magic Number 123 and how it brings the ambulance.
        </p>
      </transition>

      <transition name="fadeUp" appear>
        <p v-show="slideIndex == 13" class="delay-5">
          Show them your FAST Hero’s song and dance moves.
        </p>
      </transition>
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 13" class="delay-6">
          <h2>I promise it will<br />make their day!</h2>
        </div>
      </transition>
    </div>
    <a href="#" class="highfive" @click.prevent="play">
      <transition name="fadeUp" appear>
        <img
          class="delay-4"
          v-if="slideIndex == 13"
          src="@/assets/module1/slide26/high_five.svg"
        />
      </transition>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showVid: false
    };
  },
  props: ["slideIndex"],
  methods: {
    play() {
      this.showVid = true;
      this.$nextTick(() => {
        if (this.$refs.video) {
          this.$refs.video.addEventListener(
            "ended",
            () => {
              this.showVid = false;
            },
            false
          );
        }
      });
    }
  }
};
</script>
